export default "__VITE_ASSET__CDCkdhLv__"